import { Dropdown, Menu } from "antd";
export default function ActionMenu(props){
    const { menuItems } = props; 
    return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item>
                  <div style={{ minWidth: 170 }}>
                    <div>
                      <span className="font-face-vzw fw-bold">Actions</span>
                      {
                        menuItems.map(ele=>{
                            return (
                                <div
                          className="mt-2 cursor-pointer"
                          onClick={ele.handlerFunction}
                        >
                          {ele.label}
                        </div>
                            )
                        })
                      }
                    </div>
                  </div>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <button
              className="btn btn-link text-secondary"
              onClick={(e) => e.preventDefault()}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </button>
          </Dropdown>
        );
}